import React from 'react';

import Buyers from './buyers';
import Owners from './owners';
import Sellers from './sellers';
import Tenants from './tenants';

export default function DealContacts() {
  return <React.Fragment>
    <Buyers/>
    <Sellers/>
    <Owners/>
    <Tenants/>
  </React.Fragment>;
}
